import { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { list_include_others_inventory } from "src/entity/common/common.constant";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";

const strictPathOthersInventory = [
  "/vocs-inventory/others/information",
  "/vocs-inventory/others/fill-sampling-result",
  "/vocs-inventory/others/fill-emission",
  "/vocs-inventory/others/report",
  "/vocs-inventory/others/history",
];
let oldCompany = "";
const useGoBack = () => {
  const [searchParams] = useSearchParams();
  const profile = profileStore(useShallow((state) => state.profile));
  const comapnyIdParam = searchParams.get("companyId");
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;

  // console.log(" Details : ", { profile: profile?.activeCompany, pathname, oldCompany });

  useEffect(() => {
    oldCompany = profile?.activeCompany._id || "";
  }, []);

  useEffect(() => {
    if (
      !comapnyIdParam &&
      profile?.activeCompany &&
      strictPathOthersInventory.includes(pathname) &&
      !list_include_others_inventory.includes(profile.activeCompany.companyName)
    ) {
      navigate("/vocs-inventory");
    } else if (
      comapnyIdParam &&
      profile?.activeCompany &&
      strictPathOthersInventory.includes(pathname) &&
      !list_include_others_inventory.includes(profile.activeCompany.companyName) &&
      oldCompany != profile.activeCompany._id
    ) {
      navigate("/vocs-inventory");
    }
  }, [profile?.activeCompany, pathname]);

  return null;
};

export default useGoBack;
